export const FALLBACK_PILLARS = [
  { icon: 'users', title: 'Community First', text: 'Built around holders who laugh, create, and show up for each other.' },
  { icon: 'coin', title: '$GUM Token', text: 'A meme coin with real utility, strong vibes, and long-term vision.' },
  { icon: 'gem', title: 'NFT Collectibles', text: 'Unique Buddies — colorful, rare, and made to collect.' },
  { icon: 'gamepad', title: 'Play-to-Earn', text: 'Games and rewards where fun and finance collide.' },
];

export const FALLBACK_ROADMAP_PREVIEW = [
  { phase: '01', title: 'Foundation', desc: 'Brand identity, website, tokenomics, and early community.' },
  { phase: '02', title: 'Token Launch', desc: '$GUM on Solana, listings, NFT design, and merch drops.' },
  { phase: '03', title: 'NFTs & Utility', desc: 'Series 1 mint, P2E game dev, staking, and partnerships.' },
  { phase: '04', title: 'Entertainment', desc: 'Cartoons, indie games, farming rewards, and ecosystem growth.' },
];

export const FALLBACK_SOCIALS = [
  { cls: 'yt', label: 'YouTube', url: 'https://www.youtube.com/@Gumballbuddies' },
  { cls: 'ig', label: 'Instagram', url: 'https://www.instagram.com/Gumballbuddies' },
  { cls: 'x', label: 'X', url: 'https://x.com/Gumballbuddies' },
  { cls: 'tt', label: 'TikTok', url: 'https://www.tiktok.com/@Gumballbuddies' },
];

export const FALLBACK_HERO = {
  eyebrow: 'Welcome to the universe',
  title: 'Colorful crypto.\nCartoon world.\nCommunity powered.',
  lead: 'A candy-bright universe where memes, NFTs, games, and rewards come together — built for holders who want fun and ownership.',
};

export const FALLBACK_ABOUT_HEADER = {
  eyebrow: 'Our World',
  title: 'About Gumball Buddies',
  lead: 'More than a meme coin — a wild, colorful brand where crypto meets creativity and play.',
};

export const FALLBACK_ABOUT_STORY = {
  intro: "Gumball Buddies is more than just a meme coin — it's a wild, colorful universe where crypto meets creativity, community, and fun. Born from the idea that crypto can be both entertaining and empowering, Gumball Buddies started as a meme coin with a mission: to bring people together through laughter, digital art, gaming, and rewards — all while giving everyday holders a reason to smile.",
  mission_title: 'Our Mission',
  mission_icon: 'candy',
  mission: "To build a community-first ecosystem powered by fun, financial freedom, and digital ownership. Whether you're here for the memes, the NFTs, the games, or the passive income, there's a Buddy for you.",
  building_title: "What We're Building",
  building_icon: 'gem',
  building_items: [
    { label: '$GUM Token', text: 'A meme coin with long-term utility and strong community vibes.' },
    { label: 'NFT Collections', text: 'Each Buddy is unique. Some are rare. All are collectible.' },
    { label: 'Play-to-Earn Gaming', text: 'Mobile + console experiences where fun meets finance.' },
    { label: 'Coloring Books & Merch', text: 'Real-world fun for fans of all ages.' },
    { label: 'Candy Collaborations', text: "We're sweetening the space, literally." },
    { label: 'Crypto Cartoons', text: 'Gumball Buddies stories brought to life, with future plans for animated series.' },
  ],
  audience_title: "Who It's For",
  audience_icon: 'users',
  audience: "GumballBuddies is for dreamers, doers, collectors, gamers, investors, artists, and anyone tired of taking crypto too seriously. It's time to play your part in the digital revolution and have a blast doing it.",
  evolution_image: '/imgs/evolution.png',
};

export const FALLBACK_ROADMAP_HEADER = {
  eyebrow: 'The Journey',
  title: 'Roadmap',
  lead: 'Four phases from brand launch to full entertainment ecosystem.',
};

export const FALLBACK_COMMUNITY_HEADER = {
  eyebrow: 'Stay Connected',
  title: 'Join the Community',
  lead: '@Gumballbuddies on every platform — come say hi.',
};

export const FALLBACK_ROADMAP_FULL = [
  {
    phase: '01',
    title: 'Foundation & Branding',
    subtitle: 'Now – Pre-Launch',
    bullets: [
      'Develop brand identity, logo, and character art',
      'Launch official Gumball Buddies website',
      'Create Instagram and social channels with animations',
      'Design tokenomics and utilities for the $GUM token',
      'Finalize whitepaper and smart contract structure',
      'Begin building early community (organic + teaser campaigns)',
    ],
    buddy_image: '/imgs/greenbuddy.png',
    corner: 'tl',
  },
  {
    phase: '02',
    title: 'Token Launch & Ecosystem Setup',
    subtitle: null,
    bullets: [
      'Deploy the Gumball Buddies Token ($GUM) on Solana',
      'Provide initial liquidity on Raydium or Orca',
      'Launch airdrop or whitelist for early supporters',
      'Submit CoinGecko & CoinMarketCap listing applications',
      'Start first NFT collection design with rarity tiers',
      'Grow Telegram and expand social reach',
      'Open premium merch store (limited drops)',
    ],
    buddy_image: '/imgs/bluebuddy.png',
    corner: 'tr',
  },
  {
    phase: '03',
    title: 'NFTs & Utility Expansion',
    subtitle: null,
    bullets: [
      'Mint and launch Gumball Buddies NFT Series 1',
      'Begin development of Play-to-Earn tycoon game',
      'Introduce NFT staking or holder rewards (if feasible)',
      'Partner with influencers or meme communities for exposure',
      'Begin talks for candy collaboration/branding',
    ],
    buddy_image: '/imgs/brownbuddy.png',
    corner: 'br',
  },
  {
    phase: '04',
    title: 'Entertainment & Ecosystem Growth',
    subtitle: 'Month 6–12',
    bullets: [
      'Develop animated Gumball Buddies shorts or web series',
      'Beta test Gumball Buddies indie game (console or app)',
      'Launch token farming or P2E reward model',
      'Expand the merch line + limited NFT-backed gear',
      'Strategic partnerships with crypto/NFT/culture brands',
      'Expand exchange listings + cross-chain bridge research',
    ],
    buddy_image: '/imgs/redbuddy.png',
    corner: 'br',
  },
];
